<template>
  <div>
    <v-flex sm10 offset-sm1 style="padding: 0; min-height: 250px; overflow: visible; height: 250px;" v-if="showform">
      <div style="font-size: 17px; overflow: hidden; white-space: nowrap;"> Documents submitted by committee members </div>
      <v-toolbar flat style="background-color: rgb(219, 219, 182); height: 57px;">
          <v-toolbar-items class="hidden-sm-and-down"
            v-if="((this.$store.getters.getUsertype === 'admin') || (this.$store.getters.getUsertype === 'committee'))">
            <input id="fileinput" type="text" class="form-control" placeholder=" Choose file to upload..." :value="attachmentfilelist">
              <button id="fileselectbtn" class="btn btn-default" type="button" @click="launchFilePicker">
                <span id="filepaperclip" class="glyph ion-paperclip" aria-hidden="true"></span>
              </button>
            <input type="file" style="display:none" multiple="multiple" id="attachments" @change="uploadFieldChange" ref="committeefile">
        </v-toolbar-items>
        <v-progress-linear
        v-if="applicationactivepage === 'verifiedapplications'"
        style="margin-top: -7px; margin-left: 7px;"
          :indeterminate="false"
          :query="false"
          v-model="percentCompleted"
          :active="progressbarvisable"
        ></v-progress-linear>
    </v-toolbar>
      <v-card color="white" flat style="overflow-y: scroll; margin-right: 0px; height: 160px; border-left: 1px solid grey !important; border-right: 1px solid grey !important; border-bottom: 1px solid grey !important;">
        <div v-if="committeedetailslist.length === 0">
          <br>
          <label style="padding-left: 20px;"> No files found </label>
        </div>
        <v-list-tile
          two-line
          style="border-bottom: 1px solid #dbdbb6; list-style-type: none;"
          v-for="(committeedetails, index) in committeedetailslist" v-bind:key="index">

        <v-list-tile-content>
            <v-list-tile-title style="width: 250px;"><a v-bind:href="urlreadfile + 'committee/' + committeedetails.user_id + '/' + committeedetails.name.replace(/\+/g,'%2B')"> {{ committeedetails.name }}</a></v-list-tile-title>
          <v-list-tile-sub-title style="width: 250px; color:grey"> Uploaded by: {{ committeedetails.uploadedby }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-content>
            <v-list-tile-title style="padding-left: 10px; width: 100px;  color:grey" v-html="committeedetails.lastModifiedDate"></v-list-tile-title>
            <v-list-tile-sub-title style="padding-left: 10px; width: 100px; color: grey;" v-html="Number((committeedetails.size / 1024 ).toFixed(1)) + ' KB'"> </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-content>
            <v-list-tile-title @click="removeAttachment(committeedetails)">
              <button title="Delete" style="font-size: 20px;" class="ion-trash-a" v-if="(committeedetails.user_id === $store.getters.getUserid)"> </button>
            </v-list-tile-title>
        </v-list-tile-content>
        </v-list-tile>
      </v-card>
    </v-flex>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">Confirm</v-card-title>
        <v-card-text>Do you want to delete the file: <br><br> {{deletefile}} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="deleteattachmentfromserver()">Yes</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>

import FilesService from '@/services/FilesService'

export default {
  watch: {
    applicationid: function () {
      this.refreshattachmentlist()
    }
  },
  computed: {
    disablecheckbox () {
      let defaultvalue = true
      if (this.applicationactivepage === 'pendingapplications') {
        if ((this.$store.getters.getUsertype === 'user') || (this.$store.getters.getUsertype === 'admin')) {
          defaultvalue = false
        }
      }
      return defaultvalue
    },
    applicationactivepage () {
      return this.$store.getters.getApplicationactivepage
    },
    applicationid () {
      if (this.applicationactivepage === 'submittedapplications') {
        return this.$store.getters.getSelectedapplicationidsubmitted
      }
      if (this.applicationactivepage === 'pendingapplications') {
        return this.$store.getters.getSelectedapplicationidpending
      }
      if (this.applicationactivepage === 'approvedapplications') {
        return this.$store.getters.getSelectedapplicationidapproved
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        return this.$store.getters.getSelectedapplicationidrejected
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        return this.$store.getters.getSelectedapplicationidverified
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        return this.$store.getters.getSelectedapplicationidcancelled
      }
    },
    urlreadfile () {
      return this.$store.getters.getBaseurl + 'attachedfiles/read?application_id=' + this.applicationid +
        '&token=' + this.$store.getters.gettoken + '&filename='
    },
    readonly () {
      if (this.$store.getters.getUsertype === 'user') {
        return true
      }
    },
    showform () {
      let tempvalue = true
      /*
      if (this.applicationactivepage === 'submittedapplications') {
        tempvalue = false
      }
      **/
      return tempvalue
    },
    showupload () {
      let defaultvalue = false
      if (this.applicationactivepage === 'verifiedapplications') {
        if ((this.$store.getters.getUsertype === 'committee') || (this.$store.getters.getUsertype === 'admin')) {
          defaultvalue = true
        }
      }
      return defaultvalue
    }
  },
  data () {
    return {
      testvalue: 0,
      valid: true,
      data: new FormData(),
      committeedetailslist: [],
      verified: true,
      anchorref: null,
      dialog: false,
      committeefile: '',
      confirmdeletefile: false,
      // File selected to be deleted
      deletefile: '',
      deletefilefolder: '',
      // Array of files selected for upload
      attachments: [],
      // List of files to upload in string format
      attachmentfilelist: '',
      percentCompleted: 0,
      progressbarvisable: false,

      // Config for axios header
      config: {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
        onUploadProgress: function (progressEvent) {
          this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log('completed' + this.percentCompleted)
        }.bind(this)
      }
    }
  },
  methods: {
    refreshattachmentlist () {
      if (this.applicationactivepage === 'submittedapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistsubmitted[this.applicationid].committeefiles
        } catch (error) {
          this.committeedetailslist = []
        }
      }
      if (this.applicationactivepage === 'pendingapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistpending[this.applicationid].committeefiles
          console.log(this.$store.getters.getApplicationslistpending[this.applicationid])
        } catch (error) {
          this.committeedetailslist = []
        }
      }
      if (this.applicationactivepage === 'approvedapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistapproved[this.applicationid].committeefiles
        } catch (error) {
          this.committeedetailslist = []
        }
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistrejected[this.applicationid].committeefiles
        } catch (error) {
          this.committeedetailslist = []
        }
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistverified[this.applicationid].committeefiles
        } catch (error) {
          this.committeedetailslist = []
        }
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        try {
          this.committeedetailslist = this.$store.getters.getApplicationslistcancelled[this.applicationid].committeefiles
        } catch (error) {
          this.committeedetailslist = []
        }
      }
    },
    update (values, event) {
      if (event.target.checked) {
        values['status'] = 1
      } else {
        values['status'] = 0
      }
      let data = new FormData()
      for (var propt in values) {
        data.append(propt, values[propt])
      }
      this.$store.dispatch('uploadVerificationvalue', data)
      this.$store.dispatch('fetchApplicationslistpending')
    },
    // Launch the file picket for uploading attachments
    launchFilePicker () {
      if (this.applicationid) {
        this.$refs.committeefile.click()
      } else {
        alert('Select first one of the application')
      }
    },
    // Prepare the correct format for uploading files
    prepareFields () {
      for (var i = this.attachments.length - 1; i >= 0; i--) {
        this.data.append('attachments[]', this.attachments[i])
        this.attachmentfilelist = this.attachmentfilelist + '/' + this.attachments[i].name
      }
      this.data.append('category_id', '1')
      this.data.append('application_id', this.applicationid)
    },
    // Popup dialog to confirm delete attachements
    removeAttachment (attachment) {
      this.deletefile = attachment.name
      // this.deletefilefolder = attachment.folder
      this.deletefilefolder = 'committee/' + attachment.user_id + '/'
      console.log('remove attachment dialog' + attachment.name)
      this.dialog = true
    },
    // This function will be called every time you add a file
    uploadFieldChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (var i = files.length - 1; i >= 0; i--) {
        this.attachments.push(files[i])
      }
      console.log('attachments committee pushed')
      console.log(this.attachments)
      this.submit()
    },
    // Start uploading the attachments
    submit () {
      this.prepareFields()
      this.sendfile()
    },
    // Start the upload attachements progress bar
    loading () {
      this.progressbarvisable = false
    },
    // Logout and go to the front-page when repy code is 401 for call to the server
    logout () {
      this.$store.dispatch('logout')
      this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
      this.$router.push({
        name: 'frontpage'
      })
    },
    // Send attachment call to the FileService
    async sendfile () {
      try {
        this.progressbarvisable = true
        const response = await FilesService.uploadreviewcommitteefile(this.data, this.config)
        if (response.status) {
          this.$toastr('success', 'Documents uploaded!', 'Success')
          this.resetData()
          if (this.applicationactivepage === 'submittedapplications') {
            this.$store.dispatch('fetchApplicationslistsubmitted').then(response => {
              this.committeedetailslist = this.$store.getters.getApplicationslistsubmitted[this.applicationid].committeefiles
            }).catch(error => {
              console.log(error)
              this.$toastr('Errors', 'Could not get the files from the server', 'Error')
            })
          }
          if (this.applicationactivepage === 'pendingapplications') {
            this.$store.dispatch('fetchApplicationslistpending').then(response => {
              this.committeedetailslist = this.$store.getters.getApplicationslistpending[this.applicationid].committeefiles
            }).catch(error => {
              console.log(error)
              this.$toastr('Errors', 'Could not get the files from the server', 'Error')
            })
          }
          if (this.applicationactivepage === 'approvedapplications') {
            this.$store.dispatch('fetchApplicationslistapproved').then(response => {
              this.committeedetailslist = this.$store.getters.getApplicationslistapproved[this.applicationid].committeefiles
            }).catch(error => {
              console.log(error)
              this.$toastr('Errors', 'Could not get the files from the server', 'Error')
            })
          }
          if (this.applicationactivepage === 'rejectedapplications') {
            this.$store.dispatch('fetchApplicationslistrejected').then(response => {
              this.committeedetailslist = this.$store.getters.getApplicationslistrejected[this.applicationid].committeefiles
            }).catch(error => {
              console.log(error)
              this.$toastr('Errors', 'Could not get the files from the server', 'Error')
            })
          }
          if (this.applicationactivepage === 'cancelledapplications') {
            this.$store.dispatch('fetchApplicationslistcancelled').then(response => {
              this.committeedetailslist = this.$store.getters.getApplicationslistcancelled[this.applicationid].committeefiles
            }).catch(error => {
              console.log(error)
              this.$toastr('Errors', 'Could not get the files from the server', 'Error')
            })
          }
          setTimeout(this.loading, 700)
        } else {
          this.$toastr('error', 'Something went wrong!', 'Error')
          setTimeout(this.loading, 700)
        }
        setTimeout(this.loading, 700)
      } catch (e) {
        console.log('send file error:' + e)
        if (e.response.status === 401) {
          this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
          this.logout()
        }
        setTimeout(this.loading, 700)
      }
    },
    // Delete attachment call to the FileService
    async deleteattachmentfromserver () {
      this.dialog = false
      try {
        const response = await FilesService.deletefile({
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
          params: {'filename': this.deletefilefolder + this.deletefile, 'application_id': this.applicationid, 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken}
        })
        if (response.status) {
          this.$toastr('success', 'File deleted', 'Success')
          this.resetData()
          this.$store.dispatch('fetchApplicationslistverified').then(response => {
            this.committeedetailslist = this.$store.getters.getApplicationslistverified[this.applicationid].committeefiles
          }).catch(error => {
            console.log(error)
            this.$toastr('Errors', 'Could not get the files from the server', 'Error')
          })
        } else {
          this.$toastr('error', 'Something went wrong with the delete!', 'Error')
        }
      } catch (e) {
        console.log('delete file error:' + e)
      }
    },
    // We want to clear the FormData object on every upload so we can re-calculate new files again.
    resetData () {
      this.data = new FormData() // Reset it completely
      this.attachments = []
      this.attachmentfilelist = ''
    }
  },
  created () {

  },
  mounted () {
    this.refreshattachmentlist()
  }
}
</script>

<style>
.newheader {
  background-color: rgb(219, 219, 182);
  height: 40px !important;
}
.tablerow {
  background-color: #f9fafc;
}
table.table thead tr {
  height: 30px;
}
</style>

<style scoped>
@import '@../../../assets/css/ionicons.min.css';

#fileinput {
  width: 150px;
  height: 25px;
  border: 1px solid black;
  border-top-left-radius: .3rem;
  border-bottom-left-radius: .3rem;
  background-color: lightgrey;
  font-size: 12px;
}
#fileselectbtn {
  min-width: 35px;
  height:25px;
  padding: 0 0 0 0;
  border: 1px solid black;
  border-top-right-radius: .3rem;
  border-bottom-right-radius: .3rem;
  background-color: white;
  margin-left: -1px;
  margin-top: 0px;
}
#filepaperclip {
  font-size:24px;
  transform: rotate(45deg);
  vertical-align: top !important;
  display: flex;
  background-color: white;
}
.list__tile__title{
  font-size: 13px;
}
.list__tile__sub-title{
  font-size: 13px;
}
.list__tile{
  padding-right: 1px !important;
  height: 20px !important;
}
.column.active{
  background-color: red !important;
}
.toolbar{
  border-top: 1px black solid;
  border-left: 1px black solid;
  border-right: 1px black solid;
}
.toolbar__content{
  height: 40px !important;
}
.hidden-sm-and-down{
  padding-top: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationcommitteefiles.vue